import { Box } from '@mui/material';

import { ReportWidgetChart } from '../ReportWidgetChart';
import { ReportWidgetTable } from '../ReportWidgetTable';

import type { ComposableWidgetLayoutProps } from '../../model/types';

export const ComposableWidgetStacked = ({
    chartItems,
    visibleItems,
    visualization,
    table,
    showChart,
    loading,
    disableChartAnimation,
    isInitialLoading,
    isLoadingMore,
    hasMore,
    handleLoadMore,
    loadMoreCount,
    itemColors,
    rowClickHandler,
    detailsClickHandler,
    chartItemClickHandler,
    hoveredItemId,
    tableActiveItemId,
    chartHoverHandler,
}: ComposableWidgetLayoutProps): JSX.Element => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
        }}
    >
        {showChart && (
            <ReportWidgetChart
                items={chartItems}
                chartType={visualization.type}
                options={visualization.options}
                loading={loading}
                disableAnimation={disableChartAnimation}
                onItemClick={chartItemClickHandler}
                activeItemId={hoveredItemId ?? undefined}
                onItemHover={chartHoverHandler}
            />
        )}

        {table.enabled && (
            <ReportWidgetTable
                items={visibleItems}
                columns={table.columns}
                loading={isInitialLoading}
                loadingMore={isLoadingMore}
                hasMore={hasMore}
                onLoadMore={handleLoadMore}
                itemColors={itemColors}
                options={{
                    ...table.options,
                    loadMoreCount,
                }}
                onRowClick={rowClickHandler}
                onDetailsClick={detailsClickHandler}
                activeItemId={tableActiveItemId}
            />
        )}
    </Box>
);
